import { FormControl, FormLabel, TextField, Typography } from "@mui/material";
import { useAppDispatch } from "../../../../Redux/hooks";
import { changeSectionValue } from "../../../../Redux/reducers/cmsBuilderSlice";
import { CMSInputLabel, CMSInputWrapper } from "../styles";

type Props = {
  section: any;
  index: number;
  placeholder: string;
  label: string;
  type: string;
  header?: boolean;
};

const CMSInput: React.FC<Props> = ({
  section,
  index,
  placeholder,
  type,
  label,
  header,
}) => {
  const dispatch = useAppDispatch();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      changeSectionValue({
        value: event.target.value,
        type,
        index,
      })
    );
  };

  return (
    <FormControl sx={CMSInputWrapper}>
      {header ? (
        <Typography variant="h6" mb={1.25} fontWeight={"medium"}>
          {label}
        </Typography>
      ) : (
        <FormLabel sx={CMSInputLabel}>{label}</FormLabel>
      )}
      <TextField
        fullWidth
        placeholder={placeholder}
        value={section[type] || ""}
        onChange={handleChange}
      />
    </FormControl>
  );
};

export default CMSInput;
